import { Action } from '@ngrx/store';
import { UsuarioAutenticado } from '../../models/signIn.model'


export const SET_AUTHENTICATED = '[Auth] Set Authenticated';
export const UNSET_AUTHENTICATED = '[Auth] Unset Authenticated';

export class SetAuthenticated implements Action {
  readonly type = SET_AUTHENTICATED;
  constructor(public usuarioAutenticado: UsuarioAutenticado) {}
}

export class UnsetAuthenticated implements Action {
  readonly type = UNSET_AUTHENTICATED;
}


export type AuthActions = SetAuthenticated | UnsetAuthenticated;


